/**
 * Plain words for the evidence an analysis carries — why a claim is held
 * tentative, and which part of the page a unit is. Shared by the Evidence panel
 * and the Tentative queue so the two never describe the same thing differently.
 * See docs/FeatureDesigns/diagnosis/accuracy/diagnosis-selection-target.md.
 */

export const REASON_TEXT: Record<string, string> = {
  work_blank_or_irrelevant: 'nothing to diagnose (blank or irrelevant work)',
  no_working_for_question: 'working on the page, none of it analysed — another question’s',
  answer_unread: 'answer unread',
  stopped_before_answer: 'stopped before an answer (both readers agree there is none)',
  trust_low: 'analysis trust low',
  working_misread_suspected: 'working may be misread (answer from outside the working)',
  analyser_scorer_disagree: 'analyser and scorer disagree on the verdict',
  answer_working_contested: 'answer and working contested',
  suspect_answer_key: 'answer key under suspicion',
  readers_disagree: 'readers disagree on the answer',
  working_readers_disagree: 'readers disagree on the working',
  reading_low_confidence: 'extract-visual read part of the solution below 0.7',
  line_low_confidence: 'the cited line was read doubtfully',
  crossed_out: 'crossed-out work',
  question_number_inferred: 'question number inferred — work may be another question’s',
  misread_confirmed: 'a reviewer found the reading wrong',
  misattributed: 'a reviewer found the work is another question’s',
  answer_only: 'rests on the answer alone',
  answer_agreement_unknown: 'answer not confirmed by a second reader',
  cause_tentative: 'the analyser says another cause is also plausible',
  kind_undetermined: 'the analyser could not tell what kind of error it was',
  working_not_marked: 'about how the working reads, and the working was not marked',
};

export const UNIT_TEXT = (unitId: string): string =>
  unitId === 'answer' ? 'the answer' : unitId === 'attribution' ? 'which question' : `line ${unitId.slice(1)}`;
